module.exports = __webpack_public_path__ + "static/media/move_ITEM_to_LOADPOINT.6ecdca62.svg";